import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { loadUser, OidcProvider } from "redux-oidc"
import App from "./App"
// eslint-disable-next-line no-unused-vars
// import registerServiceWorker from "./registerServiceWorker"
import { unregister } from "./registerServiceWorker"
import configureStore from "./state/store/configureStore"
import userManager from "./utils/user-manager"

// create the middleware

const store = configureStore()
// initialise the usermanager for aith with the identityserver.
loadUser(store, userManager)

ReactDOM.render(
  // eslint-disable-next-line react/jsx-filename-extension
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <App />
    </OidcProvider>
  </Provider>,
  document.getElementById("root")
)

// registerServiceWorker() // Caused caching issues between deploys - would show a blank screen
unregister()



// WEBPACK FOOTER //
// ./src/index.js